import { useAdmin, useUser } from '.'

export function usePermissionOr(...permissions: (string | RegExp)[]) {
  const user = useUser()
  if (useAdmin()) return true

  const permitted = permissions.reduce(
    (acc, cur) =>
      acc ||
      (cur instanceof RegExp
        ? user.permissions.some(p => cur.test(p))
        : user.permissions.includes(cur)),
    false
  )

  return permitted
}
